<script setup>
import { ref } from "vue";
import MfCollapse from "@/components/core/MfCollapse.vue";
import MfEmpty from "@/components/core/MfEmpty.vue";
import ChronologySingle from "@/views/newchronology/ChronologySingle.vue";

defineProps({
  chronology: {
    type: Array,
    default: [],
    required: true,
  },
});
</script>

<template>
  <div v-if="chronology.length">
    <MfCollapse
      headerClicked
      :collapseKey="item.id"
      v-for="(item, index) in chronology"
      :key="index"
      style="background: #f7f8fc; margin-bottom: 15px"
    >
      <template #collapseHeader>
        <h4>{{ item.orderer_title }}</h4>
      </template>
      <template #collapseBody>
        <ChronologySingle :item="item" />
      </template>
    </MfCollapse>
  </div>
  <div v-else>
    <MfEmpty />
  </div>
</template>

<style scoped>
.page-title {
  font-size: 18px;
  margin-bottom: 30px;
}
.chronology-loader {
  background-color: #ffffff;
  margin-bottom: 1rem;
  padding: 0.5rem;
}
</style>
